import type { Activity } from "@lib/activity";
import { metaEvent, ensureMetaPixel } from "./meta-pixel";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

type MetaProps = {
  activity: Activity;
  code: string;
};

export function Meta({ activity, code }: MetaProps) {
  const [cookies] = useCookies([`sopost-purpose_${activity.id}`]);
  const cookie = cookies[`sopost-purpose_${activity.id}`] as string | undefined;

  useEffect(() => {
    if (!cookie || cookie === "rejected") return;
    ensureMetaPixel();
    metaEvent("init", code);
    metaEvent("track", "PageView");
  }, [code, cookie]);

  return <></>;
}
